export function decodeToken(token) {
    if (!token) return null;
    try {
        let payload = token.split('.')[1];
        payload = payload.replace(/-/g, '+').replace(/_/g, '/');
        while (payload.length % 4 !== 0) {
            payload += '=';
        }
        const decoded = atob(payload);
        return JSON.parse(decoded);
    } catch (e) {
        console.warn('Failed to decode token:', e);
        return null;
    }
}

export function isTokenExpired(token) {
    const decoded = decodeToken(token);
    if (!decoded || !decoded.exp) return true;
    const now = Date.now() / 1000;
    return decoded.exp < now;
}

export function getTokenRemainingTime(token) {
    const decoded = decodeToken(token);
    if (!decoded || !decoded.exp) return 0;
    const now = Date.now() / 1000;
    return decoded.exp - now;
}
